import React from 'react';
import { useEffect } from 'react';
import Cierre from '../../Components/Features/Cierre';
import { trackCustomEvent } from '../../Config/DataDog';
import { StepsTrackeoRedimirPin } from '../../Config/StepsTrackeoRedimirPin';
import { PageViewTrackAndLogData } from '../../Config/TrackAndLogData';
import { useStore } from '../../Store/storeProvider';

const ValidarPinGracias = () => {
    const { Config } = useStore();

    useEffect(() => {
        PageViewTrackAndLogData('validar_pines_gracias');
    }, [])

    const handleClick = () => {
        trackCustomEvent(StepsTrackeoRedimirPin[5]);
        window.location.href = Config.URLCallback;
    }

    return (
        <>
            <Cierre
                hasClub={true}
                title="Bienvenido a LA NACION sin límites"
                firstBtnLabel="Finalizar"
                onClickCierre={handleClick}
                validarPin={true}
            />
        </>
    );
};

export default ValidarPinGracias;
